import Vue from 'vue'
import Router from 'vue-router'
import articlePage from '@/pages/articlePage'
import emptyPage from '@/pages/emptyPage'
import articlePage2 from '@/pages/articlePage2'
import articlePageV3 from '@/pages/articlePageV3'
import globalSearchPageV3 from '@/pages/globalSearchPageV3'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'globalSearchPageV3',
      component: globalSearchPageV3
    },
    {
      path: '/article_page/',
      name: 'articlePage',
      component: articlePage
    },
    {
      path: '/article_page2/',
      name: 'articlePage2',
      component: articlePage2
    },
    {
      path: '/v3/article_page/',
      name: 'articlePageV3',
      component: articlePageV3
    },
    {
      path: '/v3/search_page/',
      name: 'globalSearchPageV3',
      component: globalSearchPageV3
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js